export default "__VITE_ASSET__DGJS893Q__"